<div class="section">
    <h4 class="title">User List</h4>
    <div class="row">
        <div class="col-md-4">
            <div class="search-hero">
                <input class="form-control" type="text" name="search2" style="font-family: FontAwesome;"
                    [(ngModel)]="searchQR" autocomplete="off" placeholder="&#xf002; Search...">
            </div>
        </div>
        <div class="col-md-8 text-right">
            <button type="button" class="btn btn-primary mr-0" (click)="client_form()">Add</button>
        </div>
    </div>
    <div class="doc-table">

        <div class="card-box">
            <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="true" [rows]="5"
                [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [globalFilterFields]="['type']">

                <ng-template pTemplate="header">
                    <tr class="thhead">
                        <th class="th-1">
                            S.No
                        </th>
                        <th>
                            User Type
                        </th>
                        <th>
                            User Name
                        </th>
                        <th>
                            User Address
                        </th>
                        <th>Role</th>
                        <th>Email</th>
                        <!-- <th>Created by</th>
                    <th>Modified by</th>
                    <th>Created at</th>
                    <th>Modified at</th> -->
                        <th style="width: 110px;text-align:center">
                            Action
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-item let-i="rowIndex">
                    <tr class="tdrow">
                        <td>{{i+1}}</td>
                        <td>
                            {{item.usertype}}
                        </td>
                        <td>{{item.user_name}}</td>
                        <td>{{item.current_address}}</td>
                        <td>{{item.user_role}}</td>
                        <td>
                            {{item.person_email}}
                        </td>
                      <td class="act">
                            <i style="color: #fd2c3a;" class="fa fa-trash" aria-hidden="true" (click)="Delete(item._id)"
                                pTooltip="Delete"></i>
                            <i style="color: #4CAF50;" class="fa fa-user" aria-hidden="true"
                                (click)="client_form_view(item)" pTooltip="Profile"></i>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

    </div>
</div>
